import React, { useContext, useState, useEffect } from "react";
import InternalPageHeader from "../../components/media/InternalPageHeader";
import ImgTextCard from "../../components/media/ImgTextCard";
import ArticleText from "../../components/text/ArticleText";
import ImgTextCardTyler from "../../components/media/ImgTextCardTyler";
import TitleTextArticle from "../../components/text/TitleTextArticle";
import { Container, Row, Col, Accordion, ListGroup } from "react-bootstrap";
import bgInternalImage from "../../images/Smathers-Grand-Reading-Room-Zoom-Background-2752x1392.jpg";
import booksStockImage from "../../images/booksOnShelf.jpg";
import otherBookImage from "../../images/archivals/other-book-with-qr.jpg";
import Footer from "../../components/Footer";
import { accrpArchivalsContext } from "../../contexts/ACCRPArchivalDocsContext";
import { Skeleton } from "@mui/material";
import ScrollspyResponsive from "../../components/JumplinkTest";
import SideNav from "../../components/JumplinkTest";
const ACCRPArchivalDocs = () => {
  const [archives2019Data, setArchives2019Data] = useState([]);
  const [archives2020Data, setArchives2020Data] = useState([]);
  const [archives2021Data, setArchives2021Data] = useState([]);
  const [archives2022Data, setArchives2022Data] = useState([]);
  const [archives2023Data, setArchives2023Data] = useState([]);
  const [archives2025Data, setArchives2025Data] = useState([]);
  const [archives2026Data, setArchives2026Data] = useState([]);
  const [historicalQuiltData, setHistoricalQuiltData] = useState([]);
  const [isArchivesDataLoading, setIsArchivesDataLoading] = useState(true);

  const { accrpArchivals, loading } = useContext(accrpArchivalsContext);

  const archivesSkeletonTiles = Array.from({ length: 3 }).map((_, index) => (
    <Col
      xs={12}
      sm={12}
      md={6}
      lg={4}
      xl={4}
      style={{
        textAlign: "center",
        color: "#00283C",
        padding: "1%",
      }}
      key={index}
    >
      <div
        style={{
          borderRadius: "3%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "6%",
          background: "#FAFAFA",
          height: "auto",
          boxShadow: "1px 2px 6px rgba(0, 0, 0, 0.25)",
        }}
      >
        <Skeleton variant="text" animation="wave" height={20} width="80%" />
        <Skeleton
          variant="text"
          animation="wave"
          height={20}
          width="60%"
          style={{ marginTop: 8 }}
        />
      </div>
    </Col>
  ));

  useEffect(() => {
    if (accrpArchivals) {
      getArchivalDocs();
    }
  }, [accrpArchivals, loading]);

  const getArchivalDocs = () => {
    const archives2019 = accrpArchivals.filter((item) =>
      item.Date.includes(2019),
    );
    const archives2020 = accrpArchivals.filter((item) =>
      item.Date.includes(2020),
    );
    const archives2021 = accrpArchivals.filter((item) =>
      item.Date.includes(2021),
    );
    const archives2022 = accrpArchivals.filter((item) =>
      item.Date.includes(2022),
    );
    const archives2023 = accrpArchivals.filter((item) =>
      item.Date.includes(2023),
    );
    const archives2025 = accrpArchivals.filter((item) =>
      item.Date.includes(2025),
    );
    const archives2026 = accrpArchivals.filter((item) =>
      item.Date.includes(2026),
    );
    const historicalQuilts = accrpArchivals.filter(
      (item) => item.Group === "Historical Quilt Data",
    );

    const archives2019Data = archives2019.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={12}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));

    const archives2020Data = archives2020.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={12}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const archives2021Data = archives2021.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={12}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const archives2022Data = archives2022.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={3}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const archives2023Data = archives2023.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={12}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const archives2025Data = archives2025.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={12}
        lg={6}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{
            color: "#00283C",
            textDecoration: "underline",
            fontSize: "16px",
          }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const archives2026Data = archives2026.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={12}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{
            color: "#00283C",
            textDecoration: "underline",
            fontSize: "16px",
          }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const historicalQuiltsData = historicalQuilts.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={12}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{
            color: "#00283C",
            textDecoration: "underline",
            fontSize: "16px",
          }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));

    setArchives2019Data(archives2019Data);
    setArchives2020Data(archives2020Data);
    setArchives2021Data(archives2021Data);
    setArchives2022Data(archives2022Data);
    setArchives2023Data(archives2023Data);
    setArchives2025Data(archives2025Data);
    setArchives2026Data(archives2026Data);
    setHistoricalQuiltData(historicalQuiltsData);
    setIsArchivesDataLoading(false);
  };

  return (
    <main className="archivalDocs">
      <InternalPageHeader
        pageHeading={"ACCRP Resources"}
        pageSubHeading={"Archival Documents"}
        inPageBGImage={bgInternalImage}
        marginBottom={"2%"}
      />

      <TitleTextArticle h2TitleText={""} />

      <Container
        className="archivalAccordion"
        backgroundColor="magenta!important"
      >
        <Row xs={12}>
          <Col
            xs={12}
            sm={12}
            md={10}
            lg={3}
            px={1}
            style={{ marginBottom: "4%" }}
            className="side-nav-container"
          >
            {/* <SideNav /> */}

            {/*  <Accordion defaultActiveKey={["0"]} alwaysOpen={true}>
              <Accordion.Item eventKey="0" className="year-2019-header" >
                <Accordion.Header className='jump-link-header'>Jump To Section</Accordion.Header>
                <Accordion.Body >
                  <ul className='jump-links'>
                    <li><a href="#2019-section">2019</a></li>
                    <li><a href="#2020-section">2020</a></li>
                    <li><a href="#2021-section">2021</a></li>
                     <li><a href="#2022-section">2022</a></li>
                      <li><a href="#2023-section">2023</a></li>
                       <li><a href="#2025-section">2025</a></li>
                        <li><a href="#2026-section">2026</a></li>
                          <li><a href="#2026-section">Quilt Historical Data</a></li>
             
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
 */}
          </Col>

          <Col xs={12} sm={12} md={12} lg={12}>
            <ArticleText
              articleText={`This section includes media and archival resources associated with the activities of the ACCRP and its eight subcommittees since 2019. We have compiled the weblinks for all our publicly held events, available for viewing on YouTube, as well as any available PDF documents and flyers, some of which include soil collection ceremonies, historical marker dedications and more. Those files have been organized chronologically. `}
            />

            <Accordion
              defaultActiveKey={["0"]}
              alwaysOpen="true"
              style={{ paddingBottom: "2%" }}
            >
              <Accordion.Item eventKey="0" id="2019-section">
                <Accordion.Header
                  as="h3"
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2019</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2019Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Accordion
              defaultActiveKey={["0"]}
              alwaysOpen="true"
              style={{ paddingBottom: "2%", paddingBottom: "2%" }}
            >
              <Accordion.Item eventKey="0" id="2020-section">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2020</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2020Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Accordion
              defaultActiveKey={["0"]}
              alwaysOpen="true"
              style={{ paddingBottom: "2%", paddingBottom: "2%" }}
            >
              <Accordion.Item eventKey="0" id="2021-section">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2021</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2021Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Accordion
              defaultActiveKey={["0"]}
              alwaysOpen="true"
              style={{ paddingBottom: "2%", paddingBottom: "2%" }}
            >
              <Accordion.Item eventKey="0" id="2022-section">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2022</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2022Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Accordion
              defaultActiveKey={["0"]}
              alwaysOpen="true"
              style={{ paddingBottom: "2%", paddingBottom: "2%" }}
            >
              <Accordion.Item eventKey="0" id="2023-section">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2023</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2023Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Accordion
              defaultActiveKey={["0"]}
              alwaysOpen="true"
              style={{ paddingBottom: "2%", paddingBottom: "2%" }}
            >
              <Accordion.Item eventKey="0" id="2025-section">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2025</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2025Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Accordion
              defaultActiveKey={["0"]}
              alwaysOpen="true"
              style={{ paddingBottom: "2%", paddingBottom: "2%" }}
            >
              <Accordion.Item eventKey="0" id="2026-section">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3 id="#2026section">2026</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2026Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          {/*   <Accordion
              defaultActiveKey={["0"]}
              alwaysOpen="true"
              style={{ paddingBottom: "2%", paddingBottom: "2%" }}
            >
              <Accordion.Item eventKey="0" id="historical-section">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3 id="#historical-section">Quilt Historical Data</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : historicalQuiltData}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion> */}
          </Col>
        </Row>
      </Container>

      <Container className="addMarginArchivePg">
        <Row>{loading && <p style={{ color: "#FFFFFF" }}> Loading...</p>}</Row>
      </Container>
      <Footer />
    </main>
  );
};

export default ACCRPArchivalDocs;
